export default "import { VuiInProgress } from \"../../../lib\";\n\nexport const InProgress = () => {\n  return <VuiInProgress label=\"Enciphering\" />;\n};\n";